import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { DASHBOARD } from '@config/modelsConfig';
import { DashboardFiltersWrapper } from '@layout/DashboardFilters';
import { DatePicker, Button } from '@atoms';
import { TextInput } from '@molecules';
import messages from './messages';

class OrganizationsFilters extends PureComponent {
  static propTypes = {
    setFilterField: PropTypes.func.isRequired,
    applyFilter: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    filterNameField: PropTypes.string,
  };

  static defaultProps = {};

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.applyFilter();
  };

  setFilter = ({ target: { value } }) => this.props.setFilterField({ name: value });

  render() {
    const { isFetching, filterNameField } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <DashboardFiltersWrapper>
          <TextInput
            id="filter-name-filed"
            value={filterNameField}
            onChange={this.setFilter}
            label={<FormattedMessage {...messages.byOrganizationName} />}
            inline
            gap="5px"
            icon="magnifyingGlass"
          />
          <Button small disabled={isFetching}>
            <FormattedMessage {...messages.filter} />
          </Button>
        </DashboardFiltersWrapper>
      </form>
    );
  }
}

export default OrganizationsFilters;



// WEBPACK FOOTER //
// ./components/molecules/OrganizationFilters/OrganizationFilters.js